export const getCategories = async (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: {}
  }

  return fetch(`${apiInstance.apiURL}/Categories`, requestParameters)
}

export const getDolarValue = async (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: {}
  }

  return fetch(
    `${apiInstance.apiURL}/Products/GetDolarValue`,
    requestParameters
  )
}

export const getSliders = async (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: {}
  }

  return fetch(`${apiInstance.apiURL}/GetSliders`, requestParameters)
}

export const getMostSalesProducts = (apiInstance, codList) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Products/GetMostSalesProducts?idListaPrecios=${codList}`,
    requestParameters
  )
}

export const getProductsByCategory = async (apiInstance, url, signal) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(`${apiInstance.apiURL}/Products/GetByCategory/${url}`, {
    ...requestParameters,
    signal
  })
}

export const getProductsById = async (apiInstance, idClient, idProduct) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Products/${idClient},${idProduct}`,
    requestParameters
  )
}

export const getProductsSearched = async (apiInstance, url, signal) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(`${apiInstance.apiURL}/Products/Search/${url}`, {
    ...requestParameters,
    signal
  })
}

export const getColors = async (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(`${apiInstance.apiURL}/Products/GetColores`, requestParameters)
}

export const getSizes = async (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(`${apiInstance.apiURL}/Products/GetTalles`, requestParameters)
}
